import { observable, decorate, action } from 'mobx'

export class BenzobotStore {
  stations = []


  constructor(rootStore) {
    this.rootStore = rootStore
    // this.stations = []
  }
  init(result) {
    this.stations = result.stations
  }

  setStations({ stations }) {
    this.stations = stations
  }
}

decorate(BenzobotStore, {
  stations: observable,
  setStations: action.bound,
})
